/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import { connectRequests } from '../../../higherOrderComponents/requests';

function mapStateToRequests(state, props) {
  const _key = props.match.params.instanceKey;
  return {
    instances: {
      url: '/instances/status/preview',
      onLoad: true
    },
    searchResults: {
      url: `/search/${_key}`,
      onLoad: true,
    }
  };
}

export default connectRequests(mapStateToRequests);
